import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { SearchButton } from "../../search-button";
import StarRating from "../../star-rating/star-rating";
import styles from "./verdict.module.css";
import sharedStyles from "../../../car-reviews-v2.module.css";
export var Verdict = function(param) {
    var title = param.title, body = param.body, starRating = param.starRating, make = param.make, model = param.model, reviewSections = param.reviewSections, areVehiclesInStock = param.areVehiclesInStock;
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function() {
        trackEvent({
            eventName: "Car Review - Search for a ".concat(make, " ").concat(model),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "verdict",
                    label: "search for a vehicle",
                    action: make,
                    value: model
                }
            }
        });
    };
    return /*#__PURE__*/ _jsxs("section", {
        className: sharedStyles.inner,
        id: "verdict",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.verdictInner,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.heading,
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: styles.title,
                                children: title || "The verdict"
                            }),
                            /*#__PURE__*/ _jsx(StarRating, {
                                starRating: starRating
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.sectionVerdictWrapper,
                        children: reviewSections.map(function(section, index) {
                            return /*#__PURE__*/ _jsxs("div", {
                                className: styles.sectionVerdict,
                                children: [
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: styles.verdictSectionsTitle,
                                        children: section.title
                                    }),
                                    /*#__PURE__*/ _jsxs("p", {
                                        className: styles.verdictSectionsRating,
                                        children: [
                                            section.rating,
                                            "/10"
                                        ]
                                    })
                                ]
                            }, section.title);
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.content,
                        children: [
                            body,
                            " "
                        ]
                    })
                ]
            }),
            areVehiclesInStock && /*#__PURE__*/ _jsx(SearchButton, {
                make: make,
                model: model,
                className: styles.verdictSearchButton,
                onClick: function() {
                    return handleClick();
                }
            })
        ]
    });
};
